import { POINTSHIPTRACK } from "../../actions/portal/";

export default function(state = [], action) {
  switch (action.type) {
    case POINTSHIPTRACK:
      return action.payload;
  }
  return state;
}
